var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bill_addon clr" },
    [
      _c("standart", {
        key: "bill_addon",
        attrs: {
          title: "Затвердження договору",
          is_active_result: false,
          is_active_problem: false,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }